import _ from "lodash";
import {
  useTheme,
  useMediaQuery,
  Box,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
} from "@mui/material";
import { toTitleCase } from "../../../../utils";

const GeneralToggle = ({
  label,
  value,
  setValue,
  items,
  minWidth = 150,
  fixedMinWidth = false,
}) => {
  const theme = useTheme();
  const matches = useMediaQuery(
    `(min-width:${theme.breakpoints.values.md}px) and (max-width:1100px)`
  );
  const matchesSmall = useMediaQuery(
    `(min-width:400px) and (max-width:${theme.breakpoints.values.sm}px)`
  );

  const lowerLabel = label.toLowerCase();

  const formControlMinWidth = fixedMinWidth
    ? minWidth
    : matches || matchesSmall
    ? "100%"
    : minWidth;

  return (
    <Box>
      <FormControl
        variant="outlined"
        sx={{ minWidth: formControlMinWidth }}
        size="small"
      >
        <InputLabel id={`select-${lowerLabel}-small-label`}>{label}</InputLabel>
        <Select
          labelId={`select-${lowerLabel}-small-label`}
          id={`select-${lowerLabel}-small`}
          label={label}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          sx={{ borderRadius: 2 }}
          MenuProps={{
            PaperProps: {
              sx: {
                borderRadius: 2,
              }
            }
          }}
        >
          {items.map((item) =>
            _.isPlainObject(item) ? (
              <MenuItem key={item.value} value={item.value}>
                {item.title}
              </MenuItem>
            ) : (
              <MenuItem key={item} value={item}>
                {typeof item === "string" ? toTitleCase(item) : item}
              </MenuItem>
            )
          )}
        </Select>
      </FormControl>
    </Box>
  );
};

export default GeneralToggle;
